export class CombinedInstallmentAccountItem {
	customerAccountId: string;
	amount: number;
}
